import React, { useState } from "react";
import TextField from "./TextField"
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import { useAuth } from '../authContext';
import styles from "../styles/ChangePasswordForm.module.css"
import { checkPasswordFormat, getPasswordRuleStatus } from "../utils/formater";

// Los mismos símbolos que acepta el regex de PASSWORD_RULES. Se listan uno a uno
// para poder espaciarlos: en un párrafo corrido se leen como un muro.
const SPECIAL_CHARS = ['^','$','*','.','[',']','{','}','(',')','?','-','"','!','@','#','%','&','/','\\',',','>','<',"'",':',';','|','_','~','`','+','='];


// Solo funciona para cambiar la clave por primera vez
// Se mantiene así pues para hacer un cambio de contraseña seguro se necesita un mailer
// o algo por el estilo.
export default function ChangePasswordForm() {
    const navigate = useNavigate();
    const { setTokens } = useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);  // Loading state

    const session = Cookies.get('session');

    const rules = getPasswordRuleStatus(newPassword);
    const formatOk = checkPasswordFormat(newPassword);
    // Solo se avisa del desajuste cuando ya se escribió algo en el segundo campo,
    // para no marcar en rojo mientras todavía se está tecleando.
    const mismatch = confirmPassword.length > 0 && newPassword !== confirmPassword;
    const canSubmit = formatOk && confirmPassword.length > 0 && !mismatch && !loading;

    async function handleSubmit() {
        if (!formatOk) {
            setError("La contraseña no cumple con los requisitos")
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Las contraseñas no coinciden")
            return;
        }

        setLoading(true)
        setError(null)

        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_HOST + '/auth/respondToAuthChallenge', {
                challengeName: 'NEW_PASSWORD_REQUIRED',
                challengeResponses: {
                    USERNAME: email, // assuming `email` is in scope
                    NEW_PASSWORD: newPassword,
                },
                session,
            });

            // Con MFA obligatorio, Cognito responde al cambio de clave con el
            // challenge del código y YA lo envió por correo. Hay que seguir con
            // esa misma sesión: volver a llamar a /auth/login emitiría un
            // segundo código e invalidaría el primero, y al usuario le llegan
            // dos correos sin saber cuál usar.
            if (response.data.challengeName === 'EMAIL_OTP') {
                navigate('/mfa', {
                    state: {
                        session: response.data.session,
                        email,
                        destination: response.data.challengeParameters?.CODE_DELIVERY_DESTINATION,
                    },
                });
                return;
            }

            if (response.data.challengeName === 'MFA_SETUP') {
                // MFA is required to complete sign in
                // override session cookie with new session
                Cookies.set('session', response.data.session);
            }

            // Sin challenge pendiente, se completa el ingreso con la clave nueva.
            const signInResponse = await axios.post(process.env.REACT_APP_BACKEND_HOST + '/auth/login', {
                email,
                password: newPassword,
            });


            if (signInResponse.data.error) {
                setError("Your email or password is incorrect.")
            } else if (signInResponse.data.challengeName === 'EMAIL_OTP') {
                navigate('/mfa', {
                    state: {
                        session: signInResponse.data.session,
                        email,
                        destination: signInResponse.data.challengeParameters?.CODE_DELIVERY_DESTINATION,
                    },
                });
            } else {
                // console.log(signInResponse.data)
                setTokens(signInResponse.data);
                navigate('/')
            }

        } catch (error) {
            setError(error.response?.data?.message || error.message || 'Something went wrong.');
        }

        setLoading(false)
    }

    return (
        <div>
            {error && (
                <span className={styles.errorContainer}>
                    {error}
                </span>
            )}

            <TextField label="Nueva contraseña" type="password" setValue={setNewPassword} value={newPassword}/>

            <ul className={styles.ruleList}>
                {rules.map((rule) => (
                    <li key={rule.id}>
                        <span className={rule.met ? styles.ruleMet : styles.rule}>
                            <span className={rule.met ? styles.checkMet : styles.check} aria-hidden="true">
                                {rule.met ? '✓' : '○'}
                            </span>
                            {rule.label}
                        </span>

                        {rule.id === 'special' && !rule.met && (
                            <span className={styles.charGrid}>
                                {SPECIAL_CHARS.map((char) => (
                                    <code key={char} className={styles.char}>{char}</code>
                                ))}
                            </span>
                        )}
                    </li>
                ))}
            </ul>

            <TextField label="Repetir contraseña" type="password" setValue={setConfirmPassword} value={confirmPassword}/>

            {mismatch && (
                <p className={styles.mismatch}>Las contraseñas no coinciden</p>
            )}

            <button
                onClick={handleSubmit}
                disabled={!canSubmit}
                className={styles.submitBtn}
            >
                {loading ? 'Guardando...' : 'Cambiar contraseña'}
            </button>
        </div>
    )
}
